import { matchPath } from "react-router-dom";
import { MenuItemType } from "types/menu.types";

export const buildBreadcrumbTrail = (
  menuItems: MenuItemType[],
  path: string
): MenuItemType[] => {
  const trail: MenuItemType[] = [];

  const findTrail = (items: MenuItemType[], currentPath: string): boolean => {
    for (const item of items) {
      const isMatch =
        item.path && item.path !== "/"
          ? matchPath({ path: item.path, end: false }, currentPath)
          : false;

      if (isMatch) {
        trail.push(item);

        if (item.children?.length) {
          if (findTrail(item.children, currentPath)) return true;
        }

        return true;
      }

      if (item.children?.length && findTrail(item.children, currentPath)) {
        trail.unshift(item);
        return true;
      }
    }

    return false;
  };
  findTrail(menuItems, path);
  // 👉 Nếu path === path cha → bỏ breadcrumb
  const isEqual = trail?.every(item => item.path === path);
  if (isEqual) {
    return [];
  }
  return trail;
};
